import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { SupplierDto } from './models/SupplierDto';
import { SupplierSearchCriteria } from './models/SupplierSearchCriteria';

class SuppliersService {
    public getList (criteria: SupplierSearchCriteria) {
        return Http.get<Paged<SupplierDto>>('suppliers', criteria);
    }

    public getCatalog () {
        return Http.get<SupplierDto[]>('suppliers/catalog');
    }

    public getById (id: string) {
        return Http.get<SupplierDto>('suppliers/' + id);
    }

    public create (model: SupplierDto): Promise<string> {
        return Http.post('suppliers', model);
    }

    public update (model: SupplierDto) {
        return Http.put('suppliers', model);
    }

    public remove (model: SupplierDto) {
        return Http.put('suppliers/deactivate', model);
    }
}

export default new SuppliersService();
